import { Box } from '../../../../components/Box';
import { Accordion } from '../../Accordion';
import { ContentSidebarJobPreferencesAgeGroups } from './JobPreferences/AgeGroups';
import { ContentSidebarJobPreferencesDesiredJobs } from './JobPreferences/DesiredJobs';
import { ExpectedCompensation as ContactSidebarJobPreferencesExpectedCompensation } from './JobPreferences/ExpectedCompensation';
import { useContext } from 'react';
import { ContactSidebarContext } from 'features/ContactSidebar/ContactSidebarContext';

export const ContactSidebarJobPreferences = () => {
  const { hasPreferences } = useContext(ContactSidebarContext);

  const hasAnyInformation =
    hasPreferences?.expectedCompensation ||
    hasPreferences?.ageGroups ||
    hasPreferences?.desiredJobs;

  if (!hasAnyInformation) {
    return null;
  }

  return (
    <Accordion title="Job Preferences">
      <Box>
        <div className="flex flex-col gap-3 py-1">
          <ContactSidebarJobPreferencesExpectedCompensation />
          <ContentSidebarJobPreferencesAgeGroups />
          <ContentSidebarJobPreferencesDesiredJobs />
        </div>
      </Box>
    </Accordion>
  );
};

ContactSidebarJobPreferences.displayName = 'ContactSidebarJobPreferences';
